import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { discountTheme } from "../StyledDiscountBanner";

const CenterStyled = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;

export const Title = styled.span`
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[0])};
    margin-right: 12px;
`;

export const BoldText = styled.span`
    font-weight: bold;
`;

export const BoxContainer = styled(CenterStyled)`
    width: 28px;
    padding: 2px 0px;
    flex-direction: column;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    ${setFontVariant("subsectionTitle", discountTheme.counterColor)};
    margin: 0 4px;
`;

export const Colon = styled.div`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[0])};
`;
